import { Box, Card, CardContent, Typography, CardMedia, Button } from "@mui/material";
import { sanitizeHTML } from "../../Utils/formattingUtils";
import { CustomCard } from "../CustomCard";
import MembershipFormButtons from "../MembershipFormButtons";

export const Membership = () => {
    const sections = [
        {
            title: 'Membership Types',
            content: `
                <p>
                    The club has two types of memberships that are available
                </p>
                <h3>
                    Associate Membership
                </h3>
                <p>
                    These are members who have paid their dues, however, since they have not passed the Basic Ski Test, they cannot vote or hold office. Associate members must pass the Basic Ski Test within three years in order to maintain their membership in the club.
                </p>
                <h3>
                    Full Membership
                </h3>
                <p>
                    There are members who have paid their dues and have passed the Basic Ski Test. These members have a say in the club by their right to vote and to hold office.
                </p>
                <center>
                    <p>
                        For more information 
                        <a href="mailto:info@monmouthskiclub.com">contact us</a>
                    </p>
                </center>
          `,
            image: ''
        },
        {
            title: 'Annual Dues',
            content: `
                <p>
                    The dues schedule is listed on the printable membership application.
                </p>
                <p>
                    There is a one-time initiation fee of $25 at the time of joining.
                </p>
            `,
            image: ''
        },
        {
            title: 'Documents and Forms',
            content: `
                <ul>
                    <li><a href="documents/forms/Monmouth Ski Club Bookings Form 2024-2025.xlsx">Bookings Form</a></li>
                    <li><a href='documents/forms/New_Membership_2024_2025.docx'>New Membership Form</a></li>
                    <li><a href='documents/forms/Membership_Renewal_2024_2025.docx'>Membership Renewal Form</a></li>
                </ul>
            `,
            image: ''
        }
    ]

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                p: 2,
            }}
        >
            <Typography variant="h4" color="text.primary" gutterBottom>
                Membership
            </Typography>

            <CustomCard posts={sections} />
            <MembershipFormButtons />
        </Box>
    );
}